/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import React, { useState } from 'react'
import {
  customDateTimeRenderer,
  customTextRenderer,
} from '../../../../../components/base/grid/CustomRenderer'
import utils from '../../../../../../utils/utils'

const useManualReviewEventsGrid = () => {
  const gridRef = React.useRef()
  const [gridApi, setGridApi] = useState(null)

  const onGridReady = (params) => {
    setGridApi(params.api)
  }

  const columns = [
    {
      headerName: 'User Name',
      field: 'createdBy',
      filter: false,
      cellRenderer: customTextRenderer,
    },
    {
      headerName: 'Action',
      field: 'description',
      filter: false,
      cellRenderer: customTextRenderer,
    },
    {
      headerName: 'Status',
      field: 'name',
      filter: false,
      cellRenderer: customTextRenderer,
    },

    {
      headerName: 'Date & Time',
      field: 'createdOn',
      filter: false,
      valueGetter: utils?.convertUtcDateTimeToFormattedDateTimeAgGrid,
      cellRenderer: (params) => customDateTimeRenderer(params, 'case'),
    },
  ]

  const gridRowData = {
    columnDefs: columns,
    rowData: [],
  }

  return {
    gridRef,
    gridApi,
    onGridReady,
    columns,
    gridRowData,
  }
}

export default useManualReviewEventsGrid
